import { values } from 'lodash'
import React from 'react'
import { connect } from 'react-redux'
import { Link, withRouter } from 'react-router-dom'

// Components
import Loader from 'app/views/components/Loader'
import Statistics from 'app/views/components/Statistics'
import OrganizationLayout from 'app/views/containers/Organizations/components/Layout'

// Redux
import { getPlans } from 'app/state/modules/plan'

// Utils
import analytics from 'app/views/utils/analytics'
import GenericModal from 'app/views/components/Modals/GenericModal'


class OrganizationsPlans extends React.Component {
  constructor(props) {
    super(props)
    this.onShowModal = this.onShowModal.bind(this)
  }

  componentDidMount() {
    this.props.getPlans(this.props.match.params.organization_uuid)

    analytics.page('page-organizations-plans')
  }

  onShowModal() {
    this.newPlanModal.show()
  }

  onHideModal(team = false) {
    this.newPlanModal.hide()
    this.props.history.push(`/admin/${this.props.match.params.organization_uuid}/plans/add${team ? '/team' : ''}`)
  }

  renderPlanCard(plan) {
    let lessonCount = 0
    plan.groups.map((phase) => {
      lessonCount += phase.content.length
    })

    return (
      <div key={plan.uuid} data-test-id="plan-card" className="uk-grid-match">
        <Link
          to={`/admin/${this.props.match.params.organization_uuid}/plans/${plan.uuid}`}
          className="uk-link-reset"
        >
          <div className="uk-card uk-card-default" data-test-id="plan-type-card">
            <div className="uk-card-header">
              <h3 className="uk-card-title uk-text-center">
                {plan.title}
              </h3>
            </div>
            <div className="uk-card-body" style={{ paddingTop: 20 }}>
              <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
              >
                <Statistics
                  header={plan.groups.length}
                  detail={(
                    <span>
                      Phases
                    </span>
                  )}
                />
                <Statistics
                  header={lessonCount}
                  detail={(
                    <span>
                      Lessons
                    </span>
                  )}
                />
              </div>
              <hr />
              {plan.default_plan && (
                <div className="uk-label">Default Plan</div>
              )}
              <p>
                {plan.description}
              </p>
            </div>
          </div>
        </Link>
      </div>
    )
  }

  render() {
    if (this.props.plans.length === 0) {
      return <Loader visible />
    }

    let organizationPlans = []
    let teamPlanMap = {}
    this.props.plans.map((plan) => {
      if (plan.team_uuid === null) {
        organizationPlans.push(plan)
      } else {
        if (!(plan.team_uuid in teamPlanMap)) {
          teamPlanMap[plan.team_uuid] = {
            uuid: plan.team_uuid,
            name: plan.team_name,
            plans: [],
          }
        }
        teamPlanMap[plan.team_uuid].plans.push(plan)
      }
    })

    return (
      <OrganizationLayout {...this.props} active="plans" data-test-id="organization-plans-component">
        <div className="uk-inline">
          <h1 className="uk-inline">
            Training Plans
          </h1>
          <a
            href="https://help.hackedu.io/en/articles/3117478-set-up-a-training-plan"
            data-uk-icon="icon: question; ratio: 0.8"
            style={{ padding: 10, verticalAlign: 'top' }}
            target="_blank"
            rel="noopener noreferrer"
          />
        </div>
        <button
          type="button"
          className="uk-button uk-button-primary tm-button-primary"
          style={{ float: 'right' }}
          onClick={this.onShowModal}
          // data-uk-toggle="target: #modal-confirm-create-custom-plan"
          data-test-id="create-plan-btn"
        >
          Create Custom Plan
        </button>
        <div style={{ clear: 'both' }} />

        <GenericModal
          ref={(ref) => { this.newPlanModal = ref }}
          id="create-plan"
          cancelLeft
          buttons={(
            <>
              <button
                type="button"
                onClick={() => this.onHideModal()}
                className="uk-button uk-button-primary uk-margin-right"
              >
                Organization Plan
              </button>
              <button
                onClick={() => this.onHideModal(true)}
                type="button"
                className="uk-button uk-button-secondary"
              >
                Team Plan
              </button>
            </>
          )}
          title="Create Plan"
          body={(
            <>
              <p className="uk-text-justify">
                You are about to create a new plan. A plan can be owned by an
                organization or by a team. Team plans are not shared between
                teams and if a team does not has an active plan then the default
                organization plan is used.
              </p>
              <p className="uk-text-justify">
                Please note, this will change what users on your team see when they first login (under
                the My Plan) tab of their dashboard. It will also affect the training notices sent out
                to your team.
              </p>
            </>
          )}
        />
        {this.props.loadingPlans ? (
          <Loader visible />
        )
          : (
            <>
              {(organizationPlans.length > 0) && (
                <>
                  <h3>Organization Plans</h3>
                  <div className="uk-child-width-1-3@s uk-grid-match" data-uk-grid="">
                    {organizationPlans.map((plan) => (
                      this.renderPlanCard(plan)
                    ))}
                  </div>
                </>
              )}

              {(Object.keys(teamPlanMap).length > 0) && (
                <>
                  <h3 className="uk-margin-remove-bottom">Team Plans</h3>
                  {Object.keys(teamPlanMap).map((teamId) => (
                    <div key={teamId} className="uk-padding uk-padding-remove-horizontal">
                      <h4>
                        <Link
                          to={`/admin/${this.props.match.params.organization_uuid}/teams/${teamId}`}
                          className="uk-link-reset"
                        >
                          {`${teamPlanMap[teamId].name} Team`}
                        </Link>
                      </h4>
                      <div className="uk-child-width-1-3@s" data-uk-grid="">
                        {teamPlanMap[teamId].plans.map((plan) => (
                          this.renderPlanCard(plan)
                        ))}
                      </div>
                    </div>
                  ))}
                </>
              )}
            </>
          )}
      </OrganizationLayout>
    )
  }
}

const mapStateToProps = (state) => ({
  // content
  courses: state.content.courses,
  lessonMap: state.content.lessonMap,
  tests: state.content.tests,

  // hacker
  organizations: values(state.hacker.organizationsList),
  organizationsHash: state.hacker.organizationsHash,
  // plans
  loadingPlans: state.plan.loadingPlans,
  hasLoadedPlans: state.plan.hasLoadedPlans,
  plans: state.plan.plans,

  // user
  email: state.auth.user.email,
})
const mapDispatchToProps = dispatch => ({
  getPlans: organizationId => dispatch(getPlans(organizationId)),
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(OrganizationsPlans))
